module.exports={
  "SilverDecisions": "1.1.0",
  "buildTimestamp": 1739278044471,
  "savetime": "2025-09-10T13:51:28.980Z",
  "lng": "en",
  "viewMode": "criterion1",
  "rule": "expected-value-maximization",
  "title": "Step19 - LegalCase",
  "description": "",
  "format": {
    "locales": "en",
    "payoff1": {
      "style": "currency",
      "currency": "EUR",
      "currencyDisplay": "symbol",
      "minimumFractionDigits": 0,
      "maximumFractionDigits": 0,
      "useGrouping": true
    },
    "payoff2": {
      "style": "percent",
      "currency": "USD",
      "currencyDisplay": "symbol",
      "minimumFractionDigits": 0,
      "maximumFractionDigits": 0,
      "useGrouping": true
    },
    "probability": {
      "style": "percent",
      "minimumFractionDigits": 0,
      "maximumFractionDigits": 0,
      "useGrouping": true
    }
  },
  "treeDesigner": {
    "margin": {
      "left": 550,
      "right": 500,
      "top": 200,
      "bottom": 100
    },
    "scale": 1,
    "lng": "en",
    "layout": {
      "type": "cluster",
      "nodeSize": 22,
      "limitNodePositioning": true,
      "limitTextPositioning": true,
      "gridHeight": 102,
      "gridWidth": 202,
      "edgeSlantWidthMax": 0
    },
    "fontFamily": "sans-serif",
    "fontSize": "12px",
    "fontWeight": "normal",
    "fontStyle": "normal",
    "node": {
      "strokeWidth": "2px",
      "optimal": {
        "stroke": "#006f00",
        "strokeWidth": "2px"
      },
      "label": {
        "fontSize": "1em",
        "color": "black"
      },
      "payoff": {
        "fontSize": "1em",
        "color": "black",
        "negativeColor": "#b60000"
      },
      "decision": {
        "fill": "#ff7777",
        "stroke": "#660000",
        "selected": {
          "fill": "#aa3333"
        }
      },
      "chance": {
        "fill": "#ffff44",
        "stroke": "#666600",
        "selected": {
          "fill": "#aaaa00"
        }
      },
      "terminal": {
        "fill": "#44ff44",
        "stroke": "black",
        "selected": {
          "fill": "#00aa00"
        },
        "payoff": {
          "fontSize": "1em",
          "color": "black",
          "negativeColor": "#b60000"
        }
      }
    },
    "edge": {
      "stroke": "#424242",
      "strokeWidth": "1.5",
      "optimal": {
        "stroke": "#006f00",
        "strokeWidth": "2.4"
      },
      "selected": {
        "stroke": "#045ad1",
        "strokeWidth": "3.5"
      },
      "label": {
        "fontSize": "1em",
        "color": "back"
      },
      "payoff": {
        "fontSize": "1em",
        "color": "black",
        "negativeColor": "#b60000"
      }
    },
    "probability": {
      "fontSize": "1em",
      "color": "#0000d7"
    },
    "title": {
      "fontSize": "16px",
      "fontWeight": "bold",
      "fontStyle": "normal",
      "color": "#000000",
      "margin": {
        "top": 15,
        "bottom": 10
      }
    },
    "description": {
      "show": true,
      "fontSize": "12px",
      "fontWeight": "bold",
      "fontStyle": "normal",
      "color": "#000000",
      "margin": {
        "top": 5,
        "bottom": 10
      }
    },
    "readOnly": false,
    "disableAnimations": false,
    "forceFullEdgeRedraw": false,
    "hideLabels": false,
    "hidePayoffs": false,
    "hideExpectedValues": false,
    "hideProbabilities": false,
    "hideCharts": false,
    "hideTextboxes": true,
    "hideMilestones": false,
    "raw": false,
    "payoffNames": [
      null,
      null
    ],
    "maxPayoffsToDisplay": 1,
    "milestoneNames": [
      "",
      "The client’s decision",
      "Legal issues",
      "Final outcome",
      "",
      "",
      "",
      "",
      "",
      ""
    ]
  },
  "data": {
    "code": "",
    "expressionScope": {},
    "trees": [
      {
        "computed": {
          "expected-value-maximization": {
            "childrenPayoff": [
              "438099 8589934591/8589934592"
            ],
            "payoff": [
              "438100"
            ],
            "optimal": true
          },
          "expected-value-minimization": {
            "childrenPayoff": [
              "0"
            ],
            "payoff": [
              "0"
            ],
            "optimal": true
          },
          "maxi-min": {
            "childrenPayoff": [
              "0"
            ],
            "payoff": [
              "0"
            ],
            "optimal": true
          },
          "maxi-max": {
            "childrenPayoff": [
              "3100000"
            ],
            "payoff": [
              "3100000"
            ],
            "optimal": true
          },
          "mini-min": {
            "childrenPayoff": [
              "-2000000"
            ],
            "payoff": [
              "-2000000"
            ],
            "optimal": true
          },
          "mini-max": {
            "childrenPayoff": [
              "0"
            ],
            "payoff": [
              "0"
            ],
            "optimal": true
          },
          "min-max": {
            "childrenPayoff": [
              "0",
              "0"
            ],
            "combinedPayoff": "0",
            "payoff": [
              "0",
              "0"
            ],
            "optimal": true
          },
          "max-min": {
            "childrenPayoff": [
              "438100",
              "0"
            ],
            "combinedPayoff": "438100",
            "payoff": [
              "438100",
              "0"
            ],
            "optimal": true
          },
          "min-min": {
            "childrenPayoff": [
              "0",
              "0"
            ],
            "combinedPayoff": "0",
            "payoff": [
              "0",
              "0"
            ],
            "optimal": true
          },
          "max-max": {
            "childrenPayoff": [
              "438100",
              "0"
            ],
            "combinedPayoff": "438100",
            "payoff": [
              "438100",
              "0"
            ],
            "optimal": true
          }
        },
        "childEdges": [
          {
            "computed": {
              "payoff": [
                "0",
                "0"
              ],
              "expected-value-maximization": {
                "probability": 0,
                "optimal": false
              },
              "expected-value-minimization": {
                "probability": 1,
                "optimal": true
              },
              "maxi-min": {
                "probability": 1,
                "optimal": true
              },
              "maxi-max": {
                "probability": 0,
                "optimal": false
              },
              "mini-min": {
                "probability": 0,
                "optimal": false
              },
              "mini-max": {
                "probability": 1,
                "optimal": true
              },
              "min-max": {
                "probability": 1,
                "optimal": true
              },
              "max-min": {
                "probability": 0,
                "optimal": false
              },
              "min-min": {
                "probability": 1,
                "optimal": true
              },
              "max-max": {
                "probability": 0,
                "optimal": false
              }
            },
            "name": "Settlement",
            "payoff": [
              0,
              0
            ],
            "childNode": {
              "computed": {
                "expected-value-maximization": {
                  "aggregatedPayoff": [
                    "0"
                  ],
                  "probabilityToEnter": 0,
                  "payoff": [
                    "0"
                  ]
                },
                "expected-value-minimization": {
                  "aggregatedPayoff": [
                    "0"
                  ],
                  "probabilityToEnter": "1",
                  "payoff": [
                    "0"
                  ],
                  "optimal": true
                },
                "maxi-min": {
                  "aggregatedPayoff": [
                    "0"
                  ],
                  "probabilityToEnter": "1",
                  "payoff": [
                    "0"
                  ],
                  "optimal": true
                },
                "maxi-max": {
                  "aggregatedPayoff": [
                    "0"
                  ],
                  "probabilityToEnter": 0,
                  "payoff": [
                    "0"
                  ]
                },
                "mini-min": {
                  "aggregatedPayoff": [
                    "0"
                  ],
                  "probabilityToEnter": 0,
                  "payoff": [
                    "0"
                  ]
                },
                "mini-max": {
                  "aggregatedPayoff": [
                    "0"
                  ],
                  "probabilityToEnter": "1",
                  "payoff": [
                    "0"
                  ],
                  "optimal": true
                },
                "min-max": {
                  "aggregatedPayoff": [
                    "0",
                    "0"
                  ],
                  "probabilityToEnter": "1",
                  "combinedPayoff": "0",
                  "payoff": [
                    "0",
                    "0"
                  ],
                  "optimal": true
                },
                "max-min": {
                  "aggregatedPayoff": [
                    "0",
                    "0"
                  ],
                  "probabilityToEnter": 0,
                  "combinedPayoff": "0",
                  "payoff": [
                    "0",
                    "0"
                  ]
                },
                "min-min": {
                  "aggregatedPayoff": [
                    "0",
                    "0"
                  ],
                  "probabilityToEnter": "1",
                  "combinedPayoff": "0",
                  "payoff": [
                    "0",
                    "0"
                  ],
                  "optimal": true
                },
                "max-max": {
                  "aggregatedPayoff": [
                    "0",
                    "0"
                  ],
                  "probabilityToEnter": 0,
                  "combinedPayoff": "0",
                  "payoff": [
                    "0",
                    "0"
                  ]
                }
              },
              "childEdges": [],
              "name": "Acceptable settlement \nbased on possible \noutcomes in a lawsuit",
              "code": "",
              "expressionScope": {},
              "folded": false,
              "location": {
                "x": 819,
                "y": 11.000000000000014
              },
              "type": "terminal",
              "milestone": 3,
              "expectedValue": 0,
              "p10": 0,
              "p90": 0
            },
            "expectedValue": 0,
            "p10": 0,
            "p90": 0,
            "optimal": false
          },
          {
            "computed": {
              "payoff": [
                "0",
                "0"
              ],
              "expected-value-maximization": {
                "probability": 1,
                "optimal": true
              },
              "expected-value-minimization": {
                "probability": 0,
                "optimal": false
              },
              "maxi-min": {
                "probability": 0,
                "optimal": false
              },
              "maxi-max": {
                "probability": 1,
                "optimal": true
              },
              "mini-min": {
                "probability": 1,
                "optimal": true
              },
              "mini-max": {
                "probability": 0,
                "optimal": false
              },
              "min-max": {
                "probability": 0,
                "optimal": false
              },
              "max-min": {
                "probability": 1,
                "optimal": true
              },
              "min-min": {
                "probability": 0,
                "optimal": false
              },
              "max-max": {
                "probability": 1,
                "optimal": true
              }
            },
            "name": "Lawsuit",
            "payoff": [
              "0",
              0
            ],
            "childNode": {
              "computed": {
                "expected-value-maximization": {
                  "childrenPayoff": [
                    "438099 8589934591/8589934592"
                  ],
                  "payoff": [
                    "438100"
                  ],
                  "optimal": true
                },
                "expected-value-minimization": {
                  "childrenPayoff": [
                    "438100"
                  ],
                  "payoff": [
                    "438100"
                  ]
                },
                "maxi-min": {
                  "childrenPayoff": [
                    "-2000000"
                  ],
                  "payoff": [
                    "-2000000"
                  ]
                },
                "maxi-max": {
                  "childrenPayoff": [
                    "3100000"
                  ],
                  "payoff": [
                    "3100000"
                  ],
                  "optimal": true
                },
                "mini-min": {
                  "childrenPayoff": [
                    "-2000000"
                  ],
                  "payoff": [
                    "-2000000"
                  ],
                  "optimal": true
                },
                "mini-max": {
                  "childrenPayoff": [
                    "3100000"
                  ],
                  "payoff": [
                    "3100000"
                  ]
                },
                "min-max": {
                  "childrenPayoff": [
                    "438100",
                    "0"
                  ],
                  "combinedPayoff": "-438100",
                  "payoff": [
                    "438100",
                    "0"
                  ]
                },
                "max-min": {
                  "childrenPayoff": [
                    "438100",
                    "0"
                  ],
                  "combinedPayoff": "438100",
                  "payoff": [
                    "438100",
                    "0"
                  ],
                  "optimal": true
                },
                "min-min": {
                  "childrenPayoff": [
                    "438100",
                    "0"
                  ],
                  "combinedPayoff": "-438100",
                  "payoff": [
                    "438100",
                    "0"
                  ]
                },
                "max-max": {
                  "childrenPayoff": [
                    "438100",
                    "0"
                  ],
                  "combinedPayoff": "438100",
                  "payoff": [
                    "438100",
                    "0"
                  ],
                  "optimal": true
                }
              },
              "childEdges": [
                {
                  "computed": {
                    "payoff": [
                      "-2000000",
                      "0"
                    ],
                    "probability": "3/10",
                    "expected-value-maximization": {
                      "probability": "3/10",
                      "optimal": true
                    },
                    "expected-value-minimization": {
                      "probability": "3/10"
                    },
                    "maxi-min": {
                      "probability": 0.5
                    },
                    "maxi-max": {
                      "probability": 0,
                      "optimal": false
                    },
                    "mini-min": {
                      "probability": 0.5,
                      "optimal": true
                    },
                    "mini-max": {
                      "probability": 0
                    },
                    "min-max": {
                      "probability": "3/10"
                    },
                    "max-min": {
                      "probability": "3/10",
                      "optimal": true
                    },
                    "min-min": {
                      "probability": "3/10"
                    },
                    "max-max": {
                      "probability": "3/10",
                      "optimal": true
                    }
                  },
                  "name": "Ruling not in favor",
                  "probability": ".3",
                  "payoff": [
                    "-2e6",
                    0
                  ],
                  "childNode": {
                    "computed": {
                      "expected-value-maximization": {
                        "aggregatedPayoff": [
                          "-2000000"
                        ],
                        "probabilityToEnter": "3/10",
                        "payoff": [
                          "-2000000"
                        ],
                        "optimal": true
                      },
                      "expected-value-minimization": {
                        "aggregatedPayoff": [
                          "-2000000"
                        ],
                        "probabilityToEnter": 0,
                        "payoff": [
                          "-2000000"
                        ]
                      },
                      "maxi-min": {
                        "aggregatedPayoff": [
                          "-2000000"
                        ],
                        "probabilityToEnter": 0,
                        "payoff": [
                          "-2000000"
                        ]
                      },
                      "maxi-max": {
                        "aggregatedPayoff": [
                          "-2000000"
                        ],
                        "probabilityToEnter": 0,
                        "payoff": [
                          "-2000000"
                        ]
                      },
                      "mini-min": {
                        "aggregatedPayoff": [
                          "-2000000"
                        ],
                        "probabilityToEnter": "1/2",
                        "payoff": [
                          "-2000000"
                        ],
                        "optimal": true
                      },
                      "mini-max": {
                        "aggregatedPayoff": [
                          "-2000000"
                        ],
                        "probabilityToEnter": 0,
                        "payoff": [
                          "-2000000"
                        ]
                      },
                      "min-max": {
                        "aggregatedPayoff": [
                          "-2000000",
                          "0"
                        ],
                        "probabilityToEnter": 0,
                        "combinedPayoff": "2000000",
                        "payoff": [
                          "-2000000",
                          "0"
                        ]
                      },
                      "max-min": {
                        "aggregatedPayoff": [
                          "-2000000",
                          "0"
                        ],
                        "probabilityToEnter": "3/10",
                        "combinedPayoff": "-2000000",
                        "payoff": [
                          "-2000000",
                          "0"
                        ],
                        "optimal": true
                      },
                      "min-min": {
                        "aggregatedPayoff": [
                          "-2000000",
                          "0"
                        ],
                        "probabilityToEnter": 0,
                        "combinedPayoff": "2000000",
                        "payoff": [
                          "-2000000",
                          "0"
                        ]
                      },
                      "max-max": {
                        "aggregatedPayoff": [
                          "-2000000",
                          "0"
                        ],
                        "probabilityToEnter": "3/10",
                        "combinedPayoff": "-2000000",
                        "payoff": [
                          "-2000000",
                          "0"
                        ],
                        "optimal": true
                      }
                    },
                    "childEdges": [],
                    "name": "",
                    "code": "",
                    "expressionScope": {},
                    "folded": false,
                    "location": {
                      "x": 819,
                      "y": 133.4
                    },
                    "type": "terminal",
                    "expectedValue": -2000000,
                    "p10": -2000000,
                    "p90": -2000000,
                    "charts": [
                      {
                        "nodeId": "14baa401-884d-5267-5632-08da83bc8ad3",
                        "x": 109,
                        "y": -39.00000190734863,
                        "type": "bar",
                        "active": true
                      }
                    ]
                  },
                  "expectedValue": -2000000,
                  "p10": -2000000,
                  "p90": -2000000,
                  "optimal": true
                },
                {
                  "computed": {
                    "payoff": [
                      "0",
                      "0"
                    ],
                    "probability": "7/10",
                    "expected-value-maximization": {
                      "probability": "7/10",
                      "optimal": true
                    },
                    "expected-value-minimization": {
                      "probability": "7/10"
                    },
                    "maxi-min": {
                      "probability": 0.5
                    },
                    "maxi-max": {
                      "probability": 1,
                      "optimal": true
                    },
                    "mini-min": {
                      "probability": 0.5,
                      "optimal": true
                    },
                    "mini-max": {
                      "probability": 1
                    },
                    "min-max": {
                      "probability": "7/10"
                    },
                    "max-min": {
                      "probability": "7/10",
                      "optimal": true
                    },
                    "min-min": {
                      "probability": "7/10"
                    },
                    "max-max": {
                      "probability": "7/10",
                      "optimal": true
                    }
                  },
                  "name": "Ruling in favor",
                  "probability": "#",
                  "payoff": [
                    0,
                    0
                  ],
                  "childNode": {
                    "computed": {
                      "expected-value-maximization": {
                        "childrenPayoff": [
                          "1483000"
                        ],
                        "payoff": [
                          "1483000"
                        ],
                        "optimal": true
                      },
                      "expected-value-minimization": {
                        "childrenPayoff": [
                          "1483000"
                        ],
                        "payoff": [
                          "1483000"
                        ]
                      },
                      "maxi-min": {
                        "childrenPayoff": [
                          "-2000000"
                        ],
                        "payoff": [
                          "-2000000"
                        ]
                      },
                      "maxi-max": {
                        "childrenPayoff": [
                          "3100000"
                        ],
                        "payoff": [
                          "3100000"
                        ],
                        "optimal": true
                      },
                      "mini-min": {
                        "childrenPayoff": [
                          "-2000000"
                        ],
                        "payoff": [
                          "-2000000"
                        ],
                        "optimal": true
                      },
                      "mini-max": {
                        "childrenPayoff": [
                          "3100000"
                        ],
                        "payoff": [
                          "3100000"
                        ]
                      },
                      "min-max": {
                        "childrenPayoff": [
                          "1483000",
                          "0"
                        ],
                        "combinedPayoff": "-1483000",
                        "payoff": [
                          "1483000",
                          "0"
                        ]
                      },
                      "max-min": {
                        "childrenPayoff": [
                          "1483000",
                          "0"
                        ],
                        "combinedPayoff": "1483000",
                        "payoff": [
                          "1483000",
                          "0"
                        ],
                        "optimal": true
                      },
                      "min-min": {
                        "childrenPayoff": [
                          "1483000",
                          "0"
                        ],
                        "combinedPayoff": "-1483000",
                        "payoff": [
                          "1483000",
                          "0"
                        ]
                      },
                      "max-max": {
                        "childrenPayoff": [
                          "1483000",
                          "0"
                        ],
                        "combinedPayoff": "1483000",
                        "payoff": [
                          "1483000",
                          "0"
                        ],
                        "optimal": true
                      }
                    },
                    "childEdges": [
                      {
                        "computed": {
                          "payoff": [
                            "-2000000",
                            "0"
                          ],
                          "probability": "1/10",
                          "expected-value-maximization": {
                            "probability": "1/10",
                            "optimal": true
                          },
                          "expected-value-minimization": {
                            "probability": "1/10"
                          },
                          "maxi-min": {
                            "probability": 1
                          },
                          "maxi-max": {
                            "probability": 0,
                            "optimal": false
                          },
                          "mini-min": {
                            "probability": 1,
                            "optimal": true
                          },
                          "mini-max": {
                            "probability": 0
                          },
                          "min-max": {
                            "probability": "1/10"
                          },
                          "max-min": {
                            "probability": "1/10",
                            "optimal": true
                          },
                          "min-min": {
                            "probability": "1/10"
                          },
                          "max-max": {
                            "probability": "1/10",
                            "optimal": true
                          }
                        },
                        "name": "Objections \nupheld",
                        "probability": ".1",
                        "payoff": [
                          "-2e6 ",
                          0
                        ],
                        "childNode": {
                          "computed": {
                            "expected-value-maximization": {
                              "aggregatedPayoff": [
                                "-2000000"
                              ],
                              "probabilityToEnter": "7/100",
                              "payoff": [
                                "-2000000"
                              ],
                              "optimal": true
                            },
                            "expected-value-minimization": {
                              "aggregatedPayoff": [
                                "-2000000"
                              ],
                              "probabilityToEnter": 0,
                              "payoff": [
                                "-2000000"
                              ]
                            },
                            "maxi-min": {
                              "aggregatedPayoff": [
                                "-2000000"
                              ],
                              "probabilityToEnter": 0,
                              "payoff": [
                                "-2000000"
                              ]
                            },
                            "maxi-max": {
                              "aggregatedPayoff": [
                                "-2000000"
                              ],
                              "probabilityToEnter": 0,
                              "payoff": [
                                "-2000000"
                              ]
                            },
                            "mini-min": {
                              "aggregatedPayoff": [
                                "-2000000"
                              ],
                              "probabilityToEnter": "1/2",
                              "payoff": [
                                "-2000000"
                              ],
                              "optimal": true
                            },
                            "mini-max": {
                              "aggregatedPayoff": [
                                "-2000000"
                              ],
                              "probabilityToEnter": 0,
                              "payoff": [
                                "-2000000"
                              ]
                            },
                            "min-max": {
                              "aggregatedPayoff": [
                                "-2000000",
                                "0"
                              ],
                              "probabilityToEnter": 0,
                              "combinedPayoff": "2000000",
                              "payoff": [
                                "-2000000",
                                "0"
                              ]
                            },
                            "max-min": {
                              "aggregatedPayoff": [
                                "-2000000",
                                "0"
                              ],
                              "probabilityToEnter": "7/100",
                              "combinedPayoff": "-2000000",
                              "payoff": [
                                "-2000000",
                                "0"
                              ],
                              "optimal": true
                            },
                            "min-min": {
                              "aggregatedPayoff": [
                                "-2000000",
                                "0"
                              ],
                              "probabilityToEnter": 0,
                              "combinedPayoff": "2000000",
                              "payoff": [
                                "-2000000",
                                "0"
                              ]
                            },
                            "max-max": {
                              "aggregatedPayoff": [
                                "-2000000",
                                "0"
                              ],
                              "probabilityToEnter": "7/100",
                              "combinedPayoff": "-2000000",
                              "payoff": [
                                "-2000000",
                                "0"
                              ],
                              "optimal": true
                            }
                          },
                          "childEdges": [],
                          "name": "",
                          "code": "",
                          "expressionScope": {},
                          "folded": false,
                          "location": {
                            "x": 819,
                            "y": 255.8
                          },
                          "type": "terminal",
                          "expectedValue": -2000000,
                          "p10": -2000000,
                          "p90": -2000000,
                          "charts": [
                            {
                              "nodeId": "e818924a-f70c-847e-caeb-958cf2d93365",
                              "x": 109,
                              "y": -39.000003814697266,
                              "type": "bar",
                              "active": true
                            },
                            {
                              "nodeId": "e818924a-f70c-847e-caeb-958cf2d93365",
                              "x": 60,
                              "y": -90,
                              "type": "waterfall",
                              "active": false
                            }
                          ]
                        },
                        "expectedValue": -2000000,
                        "p10": -2000000,
                        "p90": -2000000,
                        "optimal": true
                      },
                      {
                        "computed": {
                          "payoff": [
                            "0",
                            "0"
                          ],
                          "probability": "9/10",
                          "expected-value-maximization": {
                            "probability": "9/10",
                            "optimal": true
                          },
                          "expected-value-minimization": {
                            "probability": "9/10"
                          },
                          "maxi-min": {
                            "probability": 0
                          },
                          "maxi-max": {
                            "probability": 1,
                            "optimal": true
                          },
                          "mini-min": {
                            "probability": 0,
                            "optimal": false
                          },
                          "mini-max": {
                            "probability": 1
                          },
                          "min-max": {
                            "probability": "9/10"
                          },
                          "max-min": {
                            "probability": "9/10",
                            "optimal": true
                          },
                          "min-min": {
                            "probability": "9/10"
                          },
                          "max-max": {
                            "probability": "9/10",
                            "optimal": true
                          }
                        },
                        "name": "Objections \nnot upheld",
                        "probability": "#",
                        "payoff": [
                          0,
                          0
                        ],
                        "childNode": {
                          "computed": {
                            "expected-value-maximization": {
                              "childrenPayoff": [
                                "1870000"
                              ],
                              "payoff": [
                                "1870000"
                              ],
                              "optimal": true
                            },
                            "expected-value-minimization": {
                              "childrenPayoff": [
                                "1870000"
                              ],
                              "payoff": [
                                "1870000"
                              ]
                            },
                            "maxi-min": {
                              "childrenPayoff": [
                                "1000000"
                              ],
                              "payoff": [
                                "1000000"
                              ]
                            },
                            "maxi-max": {
                              "childrenPayoff": [
                                "3100000"
                              ],
                              "payoff": [
                                "3100000"
                              ],
                              "optimal": true
                            },
                            "mini-min": {
                              "childrenPayoff": [
                                "1000000"
                              ],
                              "payoff": [
                                "1000000"
                              ]
                            },
                            "mini-max": {
                              "childrenPayoff": [
                                "3100000"
                              ],
                              "payoff": [
                                "3100000"
                              ]
                            },
                            "min-max": {
                              "childrenPayoff": [
                                "1870000",
                                "0"
                              ],
                              "combinedPayoff": "-1870000",
                              "payoff": [
                                "1870000",
                                "0"
                              ]
                            },
                            "max-min": {
                              "childrenPayoff": [
                                "1870000",
                                "0"
                              ],
                              "combinedPayoff": "1870000",
                              "payoff": [
                                "1870000",
                                "0"
                              ],
                              "optimal": true
                            },
                            "min-min": {
                              "childrenPayoff": [
                                "1870000",
                                "0"
                              ],
                              "combinedPayoff": "-1870000",
                              "payoff": [
                                "1870000",
                                "0"
                              ]
                            },
                            "max-max": {
                              "childrenPayoff": [
                                "1870000",
                                "0"
                              ],
                              "combinedPayoff": "1870000",
                              "payoff": [
                                "1870000",
                                "0"
                              ],
                              "optimal": true
                            }
                          },
                          "childEdges": [
                            {
                              "computed": {
                                "payoff": [
                                  "1000000",
                                  "0"
                                ],
                                "probability": "3/10",
                                "expected-value-maximization": {
                                  "probability": "3/10",
                                  "optimal": true
                                },
                                "expected-value-minimization": {
                                  "probability": "3/10"
                                },
                                "maxi-min": {
                                  "probability": 1
                                },
                                "maxi-max": {
                                  "probability": 0,
                                  "optimal": false
                                },
                                "mini-min": {
                                  "probability": 1
                                },
                                "mini-max": {
                                  "probability": 0
                                },
                                "min-max": {
                                  "probability": "3/10"
                                },
                                "max-min": {
                                  "probability": "3/10",
                                  "optimal": true
                                },
                                "min-min": {
                                  "probability": "3/10"
                                },
                                "max-max": {
                                  "probability": "3/10",
                                  "optimal": true
                                }
                              },
                              "name": "Outcome a",
                              "probability": ".3",
                              "payoff": [
                                "1000000",
                                0
                              ],
                              "childNode": {
                                "computed": {
                                  "expected-value-maximization": {
                                    "aggregatedPayoff": [
                                      "1000000"
                                    ],
                                    "probabilityToEnter": "189/1000",
                                    "payoff": [
                                      "1000000"
                                    ],
                                    "optimal": true
                                  },
                                  "expected-value-minimization": {
                                    "aggregatedPayoff": [
                                      "1000000"
                                    ],
                                    "probabilityToEnter": 0,
                                    "payoff": [
                                      "1000000"
                                    ]
                                  },
                                  "maxi-min": {
                                    "aggregatedPayoff": [
                                      "1000000"
                                    ],
                                    "probabilityToEnter": 0,
                                    "payoff": [
                                      "1000000"
                                    ]
                                  },
                                  "maxi-max": {
                                    "aggregatedPayoff": [
                                      "1000000"
                                    ],
                                    "probabilityToEnter": 0,
                                    "payoff": [
                                      "1000000"
                                    ]
                                  },
                                  "mini-min": {
                                    "aggregatedPayoff": [
                                      "1000000"
                                    ],
                                    "probabilityToEnter": 0,
                                    "payoff": [
                                      "1000000"
                                    ]
                                  },
                                  "mini-max": {
                                    "aggregatedPayoff": [
                                      "1000000"
                                    ],
                                    "probabilityToEnter": 0,
                                    "payoff": [
                                      "1000000"
                                    ]
                                  },
                                  "min-max": {
                                    "aggregatedPayoff": [
                                      "1000000",
                                      "0"
                                    ],
                                    "probabilityToEnter": 0,
                                    "combinedPayoff": "-1000000",
                                    "payoff": [
                                      "1000000",
                                      "0"
                                    ]
                                  },
                                  "max-min": {
                                    "aggregatedPayoff": [
                                      "1000000",
                                      "0"
                                    ],
                                    "probabilityToEnter": "189/1000",
                                    "combinedPayoff": "1000000",
                                    "payoff": [
                                      "1000000",
                                      "0"
                                    ],
                                    "optimal": true
                                  },
                                  "min-min": {
                                    "aggregatedPayoff": [
                                      "1000000",
                                      "0"
                                    ],
                                    "probabilityToEnter": 0,
                                    "combinedPayoff": "-1000000",
                                    "payoff": [
                                      "1000000",
                                      "0"
                                    ]
                                  },
                                  "max-max": {
                                    "aggregatedPayoff": [
                                      "1000000",
                                      "0"
                                    ],
                                    "probabilityToEnter": "189/1000",
                                    "combinedPayoff": "1000000",
                                    "payoff": [
                                      "1000000",
                                      "0"
                                    ],
                                    "optimal": true
                                  }
                                },
                                "childEdges": [],
                                "name": "",
                                "code": "",
                                "expressionScope": {},
                                "folded": false,
                                "location": {
                                  "x": 819,
                                  "y": 378.20000000000005
                                },
                                "type": "terminal",
                                "expectedValue": 1000000,
                                "p10": 1000000,
                                "p90": 1000000,
                                "charts": [
                                  {
                                    "nodeId": "3c8d2c9e-e86f-d289-e903-482968d4b1f5",
                                    "x": 109,
                                    "y": -40,
                                    "type": "bar",
                                    "active": true
                                  }
                                ]
                              },
                              "expectedValue": 1000000,
                              "p10": 1000000,
                              "p90": 1000000,
                              "optimal": true
                            },
                            {
                              "computed": {
                                "payoff": [
                                  "1600000",
                                  "0"
                                ],
                                "probability": "2/5",
                                "expected-value-maximization": {
                                  "probability": "2/5",
                                  "optimal": true
                                },
                                "expected-value-minimization": {
                                  "probability": "2/5"
                                },
                                "maxi-min": {
                                  "probability": 0
                                },
                                "maxi-max": {
                                  "probability": 0,
                                  "optimal": false
                                },
                                "mini-min": {
                                  "probability": 0
                                },
                                "mini-max": {
                                  "probability": 0
                                },
                                "min-max": {
                                  "probability": "2/5"
                                },
                                "max-min": {
                                  "probability": "2/5",
                                  "optimal": true
                                },
                                "min-min": {
                                  "probability": "2/5"
                                },
                                "max-max": {
                                  "probability": "2/5",
                                  "optimal": true
                                }
                              },
                              "name": "Outcome b",
                              "probability": ".4",
                              "payoff": [
                                "1600000",
                                0
                              ],
                              "childNode": {
                                "computed": {
                                  "expected-value-maximization": {
                                    "aggregatedPayoff": [
                                      "1600000"
                                    ],
                                    "probabilityToEnter": "63/250",
                                    "payoff": [
                                      "1600000"
                                    ],
                                    "optimal": true
                                  },
                                  "expected-value-minimization": {
                                    "aggregatedPayoff": [
                                      "1600000"
                                    ],
                                    "probabilityToEnter": 0,
                                    "payoff": [
                                      "1600000"
                                    ]
                                  },
                                  "maxi-min": {
                                    "aggregatedPayoff": [
                                      "1600000"
                                    ],
                                    "probabilityToEnter": 0,
                                    "payoff": [
                                      "1600000"
                                    ]
                                  },
                                  "maxi-max": {
                                    "aggregatedPayoff": [
                                      "1600000"
                                    ],
                                    "probabilityToEnter": 0,
                                    "payoff": [
                                      "1600000"
                                    ]
                                  },
                                  "mini-min": {
                                    "aggregatedPayoff": [
                                      "1600000"
                                    ],
                                    "probabilityToEnter": 0,
                                    "payoff": [
                                      "1600000"
                                    ]
                                  },
                                  "mini-max": {
                                    "aggregatedPayoff": [
                                      "1600000"
                                    ],
                                    "probabilityToEnter": 0,
                                    "payoff": [
                                      "1600000"
                                    ]
                                  },
                                  "min-max": {
                                    "aggregatedPayoff": [
                                      "1600000",
                                      "0"
                                    ],
                                    "probabilityToEnter": 0,
                                    "combinedPayoff": "-1600000",
                                    "payoff": [
                                      "1600000",
                                      "0"
                                    ]
                                  },
                                  "max-min": {
                                    "aggregatedPayoff": [
                                      "1600000",
                                      "0"
                                    ],
                                    "probabilityToEnter": "63/250",
                                    "combinedPayoff": "1600000",
                                    "payoff": [
                                      "1600000",
                                      "0"
                                    ],
                                    "optimal": true
                                  },
                                  "min-min": {
                                    "aggregatedPayoff": [
                                      "1600000",
                                      "0"
                                    ],
                                    "probabilityToEnter": 0,
                                    "combinedPayoff": "-1600000",
                                    "payoff": [
                                      "1600000",
                                      "0"
                                    ]
                                  },
                                  "max-max": {
                                    "aggregatedPayoff": [
                                      "1600000",
                                      "0"
                                    ],
                                    "probabilityToEnter": "63/250",
                                    "combinedPayoff": "1600000",
                                    "payoff": [
                                      "1600000",
                                      "0"
                                    ],
                                    "optimal": true
                                  }
                                },
                                "childEdges": [],
                                "name": "",
                                "code": "",
                                "expressionScope": {},
                                "folded": false,
                                "location": {
                                  "x": 819,
                                  "y": 480.2
                                },
                                "type": "terminal",
                                "expectedValue": 1600000,
                                "p10": 1600000,
                                "p90": 1600000,
                                "charts": [
                                  {
                                    "nodeId": "e1585350-5499-2c46-fcd5-07709934e91c",
                                    "x": 110,
                                    "y": -40,
                                    "type": "bar",
                                    "active": true
                                  }
                                ]
                              },
                              "expectedValue": 1600000,
                              "p10": 1600000,
                              "p90": 1600000,
                              "optimal": true
                            },
                            {
                              "computed": {
                                "payoff": [
                                  "3100000",
                                  "0"
                                ],
                                "probability": "3/10",
                                "expected-value-maximization": {
                                  "probability": "3/10",
                                  "optimal": true
                                },
                                "expected-value-minimization": {
                                  "probability": "3/10"
                                },
                                "maxi-min": {
                                  "probability": 0
                                },
                                "maxi-max": {
                                  "probability": 1,
                                  "optimal": true
                                },
                                "mini-min": {
                                  "probability": 0
                                },
                                "mini-max": {
                                  "probability": 1
                                },
                                "min-max": {
                                  "probability": "3/10"
                                },
                                "max-min": {
                                  "probability": "3/10",
                                  "optimal": true
                                },
                                "min-min": {
                                  "probability": "3/10"
                                },
                                "max-max": {
                                  "probability": "3/10",
                                  "optimal": true
                                }
                              },
                              "name": "Outcome c",
                              "probability": "#",
                              "payoff": [
                                "3100000",
                                0
                              ],
                              "childNode": {
                                "computed": {
                                  "expected-value-maximization": {
                                    "aggregatedPayoff": [
                                      "3100000"
                                    ],
                                    "probabilityToEnter": "189/1000",
                                    "payoff": [
                                      "3100000"
                                    ],
                                    "optimal": true
                                  },
                                  "expected-value-minimization": {
                                    "aggregatedPayoff": [
                                      "3100000"
                                    ],
                                    "probabilityToEnter": 0,
                                    "payoff": [
                                      "3100000"
                                    ]
                                  },
                                  "maxi-min": {
                                    "aggregatedPayoff": [
                                      "3100000"
                                    ],
                                    "probabilityToEnter": 0,
                                    "payoff": [
                                      "3100000"
                                    ]
                                  },
                                  "maxi-max": {
                                    "aggregatedPayoff": [
                                      "3100000"
                                    ],
                                    "probabilityToEnter": "1",
                                    "payoff": [
                                      "3100000"
                                    ],
                                    "optimal": true
                                  },
                                  "mini-min": {
                                    "aggregatedPayoff": [
                                      "3100000"
                                    ],
                                    "probabilityToEnter": 0,
                                    "payoff": [
                                      "3100000"
                                    ]
                                  },
                                  "mini-max": {
                                    "aggregatedPayoff": [
                                      "3100000"
                                    ],
                                    "probabilityToEnter": 0,
                                    "payoff": [
                                      "3100000"
                                    ]
                                  },
                                  "min-max": {
                                    "aggregatedPayoff": [
                                      "3100000",
                                      "0"
                                    ],
                                    "probabilityToEnter": 0,
                                    "combinedPayoff": "-3100000",
                                    "payoff": [
                                      "3100000",
                                      "0"
                                    ]
                                  },
                                  "max-min": {
                                    "aggregatedPayoff": [
                                      "3100000",
                                      "0"
                                    ],
                                    "probabilityToEnter": "189/1000",
                                    "combinedPayoff": "3100000",
                                    "payoff": [
                                      "3100000",
                                      "0"
                                    ],
                                    "optimal": true
                                  },
                                  "min-min": {
                                    "aggregatedPayoff": [
                                      "3100000",
                                      "0"
                                    ],
                                    "probabilityToEnter": 0,
                                    "combinedPayoff": "-3100000",
                                    "payoff": [
                                      "3100000",
                                      "0"
                                    ]
                                  },
                                  "max-max": {
                                    "aggregatedPayoff": [
                                      "3100000",
                                      "0"
                                    ],
                                    "probabilityToEnter": "189/1000",
                                    "combinedPayoff": "3100000",
                                    "payoff": [
                                      "3100000",
                                      "0"
                                    ],
                                    "optimal": true
                                  }
                                },
                                "childEdges": [],
                                "name": "",
                                "code": "",
                                "expressionScope": {},
                                "folded": false,
                                "location": {
                                  "x": 819,
                                  "y": 582.2
                                },
                                "type": "terminal",
                                "expectedValue": 3100000,
                                "p10": 3100000,
                                "p90": 3100000,
                                "charts": [
                                  {
                                    "nodeId": "70b9f87d-5709-8389-c3aa-ab4effc06b1a",
                                    "x": 110,
                                    "y": -41.000003814697266,
                                    "type": "bar",
                                    "active": true
                                  }
                                ]
                              },
                              "expectedValue": 3100000,
                              "p10": 3100000,
                              "p90": 3100000,
                              "optimal": true
                            }
                          ],
                          "name": "Damages \nassessment",
                          "code": "",
                          "expressionScope": {},
                          "folded": false,
                          "location": {
                            "x": 617,
                            "y": 480.2
                          },
                          "type": "chance",
                          "milestone": null,
                          "expectedValue": 1870000,
                          "p10": 1000000,
                          "p90": 3099377
                        },
                        "expectedValue": 0,
                        "p10": 0,
                        "p90": 0,
                        "optimal": true
                      }
                    ],
                    "name": "Other \nlegal issues\nin the case",
                    "code": "",
                    "expressionScope": {},
                    "folded": false,
                    "location": {
                      "x": 415,
                      "y": 368
                    },
                    "type": "chance",
                    "milestone": null,
                    "expectedValue": 1483000,
                    "p10": 1001768,
                    "p90": 3101145
                  },
                  "expectedValue": 0,
                  "p10": 0,
                  "p90": 0,
                  "optimal": true
                }
              ],
              "name": "The primary \nlegal issue \nin the case",
              "code": "",
              "expressionScope": {},
              "folded": false,
              "location": {
                "x": 213,
                "y": 250.70000000000005
              },
              "type": "chance",
              "milestone": 2,
              "expectedValue": 438099.9999999999,
              "p10": -2000000,
              "p90": 3101145
            },
            "expectedValue": 0,
            "p10": 0,
            "p90": 0,
            "optimal": true
          }
        ],
        "name": "Settle or \nproceed with\nlitigation",
        "code": "",
        "expressionScope": {},
        "folded": false,
        "location": {
          "x": 11,
          "y": 130.85000000000002
        },
        "type": "decision",
        "milestone": 1,
        "expectedValue": 438099.9999999999,
        "p10": -2000000,
        "p90": 3101145,
        "charts": [
          {
            "nodeId": "c51fd6ed-f70f-4e12-05f3-234164630b3b",
            "x": -73.99999618530273,
            "y": 178,
            "type": "bar",
            "active": true
          }
        ]
      }
    ],
    "texts": [
      {
        "value": "Legal dispute from the \nclient’s perspective",
        "location": {
          "x": -33.151634216308594,
          "y": -185.49681854248047
        }
      }
    ],
    "payoffNames": [],
    "defaultCriterion1Weight": 1,
    "weightLowerBound": 0,
    "weightUpperBound": "Infinity"
  },
  "sensitivityAnalysis": {},
  "definitionsDialog": {
    "valueList": [
      {
        "name": null,
        "value": "",
        "low": null,
        "high": null,
        "distribution": "constant",
        "error": ""
      },
      {
        "name": null,
        "value": "",
        "low": null,
        "high": null,
        "distribution": "constant",
        "error": ""
      },
      {
        "name": null,
        "value": "",
        "low": null,
        "high": null,
        "distribution": "constant",
        "error": ""
      },
      {
        "name": null,
        "value": "",
        "low": null,
        "high": null,
        "distribution": "constant",
        "error": ""
      },
      {
        "name": null,
        "value": "",
        "low": null,
        "high": null,
        "distribution": "constant",
        "error": ""
      }
    ]
  }
}